// src/components/shared/AssetCard.js
// Filepath: // src/components/shared/AssetCard.js
import React from "react";
import { Box, Card } from "@mui/material";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import CollectionsBookmarkIcon from "@mui/icons-material/CollectionsBookmark";
import ImageRoundedIcon from "@mui/icons-material/ImageRounded";

export default function AssetCard({ item, onEnter }) {
  // Be flexible: accept either `type` or `expectedMediaType`
  const mediaType = (item?.type || item?.expectedMediaType || "")
    .toString()
    .toLowerCase();

  const isVideo = mediaType === "video";
  const isImage = mediaType === "image";
  const isCollection = item?.type === "collection";

  const BadgeIcon = isVideo
    ? PlayArrowRoundedIcon
    : isCollection
    ? CollectionsBookmarkIcon
    : isImage
    ? ImageRoundedIcon
    : null;

  return (
    <Card
      sx={{
        borderRadius: "10px",
        overflow: "hidden",
        position: "relative",
        width: "100%",
        height: "100%",
        cursor: "pointer",
        // show white focus ring when the Focusable parent has .focused
        "[data-focusable='true'].focused & [data-focus-ring]": { opacity: 1 },
        // and on keyboard focus that lands inside the card
        "&:focus-within [data-focus-ring]": { opacity: 1 },
        "&:hover [data-focus-ring]": { opacity: 1 },
      }}
      onClick={onEnter}
      data-card-click
      role="button"
    >
      {/* Image */}
      <Box
        data-card-surface
        sx={{
          position: "absolute",
          inset: 0,
          bgcolor: "grey.900",
          backgroundImage: `url(${item?.thumbnailUrl})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      {/* Lower-third gradient + title */}
      <Box
        sx={{
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0,
          height: "38%",
          background:
            "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.65) 70%, rgba(0,0,0,0.95) 100%)",
          display: "flex",
          alignItems: "flex-end",
          px: 1.5,
          pb: 1,
        }}
      >
        <Box
          sx={{
            color: "common.white",
            fontSize: 16,
            fontWeight: 700,
            lineHeight: 1.2,
            textShadow: "0 2px 6px rgba(0,0,0,0.8)",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            width: "100%",
          }}
          title={item?.title}
        >
          {item?.title || "Untitled"}
        </Box>

        {BadgeIcon && (
          <Box
            sx={{
              position: "absolute",
              right: 8,
              bottom: 8,
              width: 36,
              height: 36,
              borderRadius: "50%",
              bgcolor: "rgba(0,0,0,0.6)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
            }}
          >
            <BadgeIcon fontSize="small" />
          </Box>
        )}
      </Box>

      {/* Inset white focus ring (never clips, respects border radius) */}
      <Box
        data-focus-ring
        aria-hidden
        sx={{
          pointerEvents: "none",
          position: "absolute",
          inset: 0,
          borderRadius: "inherit",
          boxShadow: "inset 0 0 0 3px rgba(255,255,255,1)",
          opacity: 0,
          transition: "opacity 120ms ease",
        }}
      />
    </Card>
  );
}
